import React from 'react';
import DeviceList from '../components/devices/DeviceList';

const Devices: React.FC = () => {
  return <DeviceList />;
};

export default Devices;
